import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { router } from "@/utils/router";
import { HelmetProvider } from "react-helmet-async";
import { v4 as uuid } from "uuid";
import { ErrorBoundary } from "@sentry/react";

const App = () => {
  const app = (
    <HelmetProvider>
      <RouterProvider router={router} />
      <Toaster position="top-center" />
    </HelmetProvider>
  );

  if (ErrorBoundary) {
    return <ErrorBoundary>{app}</ErrorBoundary>;
  }

  return app;
};

export default App;
